import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0); // Mueve el scroll al inicio
    }, [pathname]); // Ejecuta cada vez que cambia la ruta

    return null;
};

export default ScrollToTop;
